import { wrapWithProvider } from "./wrapProvider"
export const wrapRootElement = wrapWithProvider